(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["iframe-video"]) return;
  try {
    
	const postervideo = document.querySelector('[id^="Deferred-Poster-"]');
    postervideo.addEventListener('click', function(){
        if (!this.getAttribute('loaded')) {
          const content = document.createElement('div');
          content.appendChild(this.nextElementSibling.content.firstElementChild.cloneNode(true));
          this.parentElement.setAttribute('loaded', true);
          this.parentElement.appendChild(content.querySelector('video, model-viewer, iframe')).focus();
        }
	});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["plans-slider"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".js_carousel").forEach(function (carousel) {
      if ($(carousel).hasClass("slick-initialized")) return;
      const spacing = parseInt(carousel.dataset.spacing) || 10;
      $(carousel).slick({
        slidesToShow: parseInt(carousel.dataset.visible) || 3,
        slidesToScroll: 1,
        infinite: false,
        autoplay: carousel.dataset.autoplay === "true",
        dots: true,
        arrows: true,
        appendArrows: carousel.dataset.appendArrows,
        appendDots: carousel.dataset.appendDots,
        responsive: [
          {
            breakpoint: 1920,
            settings: { slidesToShow: parseInt(carousel.dataset.widescreen) || 3 }
          },
          {
            breakpoint: 1480,
            settings: { slidesToShow: parseInt(carousel.dataset.desktop) || 3 }
          },
          {
            breakpoint: 1200,
            settings: { slidesToShow: parseInt(carousel.dataset.laptop) || 2 }
          },
          {
            breakpoint: 992,
            settings: { slidesToShow: parseInt(carousel.dataset.notebook) || 2 }
          },
          {
            breakpoint: 768,
            settings: { slidesToShow: parseInt(carousel.dataset.tablet) || 2 }
          },
          {
            breakpoint: 576,
            settings: { slidesToShow: parseInt(carousel.dataset.landscape) || 1 }
          },
          {
            breakpoint: 480,
            settings: { slidesToShow: parseInt(carousel.dataset.portrait) || 1 }
          },
          {
            breakpoint: 360,
            settings: { slidesToShow: parseInt(carousel.dataset.mobile) || 1 }
          }
        ]
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top-bar"]) return;
  try {
    
    jQuery(document).ready(function ($) {
        $('.btn-close').on('click', function(){
        $(this).parents('.parent-close').slideUp();
        })
    });

  } catch(e) { console.error(e); }
})();
})();
